import styled from 'styled-components';

import { IFacetOption } from 'shared/types/ConstructorFacet';
import {
  ConsumerSearchFilterList,
  SearchFilterList,
} from 'search/components/searchGrid/SearchFilterList';
import { UnorderedList } from 'shared/components/UnorderedList';

interface ISearchFilterGrid {
  filterOptions: Array<IFacetOption>;
  facetType: string;
  resultIds: Array<string>;
}

export const ConsumerSearchFilterGrid = ({
  filterOptions,
  name,
  handleClick,
}: {
  name: string;
  filterOptions: Array<any>;
  handleClick: any;
}) => {
  return (
    <ConsumerSearchFilterGrid.Wrapper data-qa="search_filter_grid">
      <ConsumerSearchFilterList
        filterOptions={filterOptions}
        name={name}
        handleClick={handleClick}
      />
    </ConsumerSearchFilterGrid.Wrapper>
  );
};

export const SearchFilterGrid = ({ filterOptions, facetType, resultIds }: ISearchFilterGrid) => {
  return (
    <SearchFilterGrid.Wrapper data-qa="search_filter_grid">
      <SearchFilterList filterOptions={filterOptions} facetType={facetType} resultIds={resultIds} />
    </SearchFilterGrid.Wrapper>
  );
};

const wrapperStyle = styled.div`
  ${UnorderedList} {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
  }

  a {
    min-width: 40px;
  }
`;

ConsumerSearchFilterGrid.Wrapper = wrapperStyle;

SearchFilterGrid.Wrapper = wrapperStyle;
